import React, { Component, Fragment } from "react";
import * as UTILS from "../../../../utils/Utils";
import CloseIcon from "../../../../assets/images/closeUploadWhite.svg";
import Reload from "../../../../assets/images/reload.svg";
import cloneDeep from "lodash.clonedeep";
import ErrorBoundary from "../../../../utils/ErrorBoundary";
import BUTTON from "../../../Elements/Button/Button";
import TABLEEditor from "../../../Elements/TABLE/Table";
import File from "../../../Elements/File/File";
import Text from "../../../Elements/Text/Text";
import RowColumns from "../../../Elements/Column/Columns";
import Form from "../../../Elements/Form/Form";
import HTMLEditor from "../../../Elements/HTML/Html";
import Image from "../../../Elements/Image/Image";
import Line from "../../../Elements/Line/Line";
import TimerElement from "../../../Elements/Timer/Timer";
import VideoElement from "../../../Elements/Video/Video";
import Accordion from "../../../Elements/Accordion/Accordion";
import { notification } from "antd";

import { connect } from "react-redux";
import Axios from "../../../../axios";

// import "./Blocks.scss";
let selectedBlockHeight = null;
class SaveAsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreen: false,
      saveEnabled: false,
      blockHeight: null,
      selectedCategory: null,
      activeBlock: false,
      blockSaved: false,
      blockLoader: false,
      animateModal: false,
      reloadAPI: false,
      choosenBlockElement: [],
      blockActivated: false,
    };
  }
  chooseBlock = (e, element, index) => {
    e.preventDefault();
    e.stopPropagation();
    let choosenBlockElement = this.state.choosenBlockElement;
    let elementToPush = element;
    let shouldPush = choosenBlockElement.length && choosenBlockElement.filter((blockElement) => blockElement.id === element.id);
    elementToPush.order = index;
   let newElementOrder = [...choosenBlockElement, elementToPush].sort((a, b) => a.order - b.order);
    if (shouldPush.length > 0) {

      this.setState({
        ...this.state,
        choosenBlockElement: choosenBlockElement.filter((blockElement) => blockElement.id !== element.id),
      });
    } else {

      this.setState({
        ...this.state,
        choosenBlockElement:newElementOrder,
      });
    }
  };
  saveBlock = () => {
    const blockHeight = JSON.stringify(this.state.blockHeight);
    selectedBlockHeight = 0;
    document
      .querySelectorAll(".getHeight.blockSelected")
      .forEach(function (node, index) {
        //
        selectedBlockHeight = selectedBlockHeight + node.offsetHeight - 4; // Getting element  height and reducing selected top and bottom border
      });
    //
    let postFlag = false;
    let totalHeight = 0;

    const choosenLength = this.state.choosenBlockElement.length;
    const elementToPush = UTILS.PushWithID(this.state.choosenBlockElement);
    //

    let blockDataToPush = { ...this.props.storeDATA, layout: elementToPush };
    //
    const self = this;
    var height = null;
    // var divs = document.querySelector(".blockHeightWrap").offsetHeight;
    height = selectedBlockHeight;
    let data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      td: JSON.stringify(blockDataToPush),
      t: "B",
      o: 1,
      h: height,
      // d: category !== "custom" ? "Y" : "N",
      d: "N",
      c: "custom",
    };

    if (choosenLength > 0 && elementToPush) {
      this.setState({
        blockLoader: true,
      });
      Axios.BlockService.POST_BLOCK(data).then((response) => {
        if (response.status == "200") {
          notification.success({
            message: "Success",
            description: "Block saved successfully!",
            placement: "bottomRight",
            duration: 3,
          });
          self.setState(
            {
              blockSaved: true,
              blockLoader: false,
            },
            () => {
              setTimeout(
                function () {
                  self.setState({
                    saveEnabled: false,
                    activeBlock: false,
                    blockSaved: false,
                  });
                }.bind(this),
                3000
              );
            }
          );
        }
        if (response.status == "error") {
          notification.error({
            message: "Error",
            description: "Failed to save block. Please try again.",
            placement: "bottomRight",
            duration: 4,
          });
          self.setState({
            reloadAPI: true,
            blockLoader: false,
          });
        }
      }).catch((error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while saving the block. Please try again.",
          placement: "bottomRight",
          duration: 4,
        });
        self.setState({
          reloadAPI: true,
          blockLoader: false,
        });
      });
      // .catch(error => {

      // });
    } else {
      this.setState(
        {
          activeShake: true,
        },
        () => {
          setTimeout(
            function () {
              this.setState({
                activeShake: false,
              });
            }.bind(this),
            2000
          );
        }
      );
    }
  };

  render() {
    return (
      <div id="save-as-block-container">
        <div className="modal-background">
          <div
            className="proceedWrapper"
            style={{ maxWidth: this.props.containerWidth }}
          >
            <div className="modalNote ">
              <p className={this.state.activeShake ? "shake" : " "}>
                Select section of canvas to save as a block under{" "}
                <span className="categoryName">Custom</span> by clicking on the
                desired row.
                <span
                  className="closeBlocks"
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      categorySelected: false,
                    });
                    this.props.animateModalState(false);
                  }}
                >
                  <img src={CloseIcon} />
                </span>
              </p>
            </div>
            <button className="proceedBtn">
              {this.state.blockLoader ? (
                <div className="loading"></div>
              ) : this.state.blockSaved ? (
                <div className="wrapperSaved">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 98.5 98.5"
                    enableBackground="new 0 0 98.5 98.5"
                  >
                    <path
                      className="checkmark"
                      fill="none"
                      strokeWidth="8"
                      strokeMiterlimit="10"
                      d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                    />
                  </svg>
                </div>
              ) : this.state.reloadAPI ? (
                <img onClick={() => this.saveBlock()} src={Reload} />
              ) : (
                <span onClick={() => this.saveBlock()}>Proceed</span>
              )}
            </button>
          </div>

          <div
            style={{ maxWidth: this.props.containerWidth + 7 }}
            className="modal saveAsBlockModal"
          >
            {this.props.children}
            <div className="blockHeightWrap">
              {this.props.layout &&
                this.props.layout.map((item, index) => {
                  if (item && item.data == "BUTTON") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.find((block) => {
                            return block.id == item.id;
                          })
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <BUTTON
                            element={item}
                            content={item.content}
                            Link={item.link}
                            LinkName={item.linkname}
                            LinkType={item.linktype}
                            button={item}
                            LinkOpen={item.linkopen}
                            UseSocial={item.use_social}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            ID={item.id}
                            mobileAlignment={
                              item.mobileAlignment
                                ? item.mobileAlignment
                                : "none"
                            }
                            style={item.style}
                            fontName={item.style.fontFamily}
                            fontSize={item.style.fontSize}
                            key={index}
                            borderRadius={item.style.borderRadius}
                            borderWidth={item.style.borderWidth}
                            paddingTop={item.style.paddingTop}
                            paddingRight={item.style.paddingRight}
                            paddingBottom={item.style.paddingBottom}
                            paddingLeft={item.style.paddingLeft}
                            btnMarginUnit={item.style.btnMarginUnit}
                            btnPaddingUnit={item.style.btnPaddingUnit}
                            marginTop={item.style.marginTop || 0}
                            marginRight={item.style.marginRight || 0}
                            marginBottom={item.style.marginBottom || 0}
                            marginLeft={item.style.marginLeft || 0}
                            floatVal={item.style.float}
                            buttonURL={item.buttonURL}
                            label={item.content}
                            keyID={item.id}
                            editVal={item.edit}
                            editStatus={item.edit}
                            normalTextColor={
                              item.normalBtn.txtColor.rgb || {
                                r: 255,
                                g: 255,
                                b: 255,
                                a: 1,
                              }
                            }
                            normalBtnBg={
                              item.normalBtn.btnBG.rgb || {
                                r: 12,
                                g: 50,
                                b: 84,
                                a: 1,
                              }
                            }
                            normalBtnBorder={
                              item.normalBtn.btnBorder.rgb || {
                                r: 12,
                                g: 50,
                                b: 84,
                                a: 1,
                              }
                            }
                            hoverBtnTextColor={
                              item.hoverBtn.txtColor.rgb || {
                                r: 255,
                                g: 255,
                                b: 255,
                                a: 1,
                              }
                            }
                            hoverBtnBgColor={
                              item.hoverBtn.btnBg.rgb || {
                                r: 0,
                                g: 98,
                                b: 204,
                                a: 1,
                              }
                            }
                            hoverBorder={
                              item.hoverBtn.btnBorder.rgb || {
                                r: 12,
                                g: 50,
                                b: 84,
                                a: 1,
                              }
                            }
                            float={item.style.float}
                            cloneEle={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "TEXT") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <Text
                            pagesList={this.props.pagesList}
                            mobileView={this.props.mobileView}
                            mobileAlign={
                              item.mobileAlign ? item.mobileAlign : ""
                            }
                            desktopAlign={
                              item.desktopAlign ? item.desktopAlign : ""
                            }
                            preset={this.props.preset}
                            keyID={item.id}
                            key={index}
                            itemIndex={index}
                            ID={"f" + item.id}
                            element={item}
                            editVal={item.edit}
                            selectedFont={this.props.selectedFont}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            editOption={item.edit}
                            lineHeightVal={item.style.lineHeight}
                            maxWidth={item.maxWidth}
                            textContent={item.text}
                            cloneEle={() => this.props.cloneEle(item.id)}
                            fontSize={item.style.fontSize}
                            fontName={item.style.fontFamily}
                            marginTop={item.style.marginTop || 0}
                            marginRight={item.style.marginRight || 0}
                            marginBottom={item.style.marginBottom || 0}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "IMAGE") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <Image
                            mobileView={this.props.mobileView}
                            mobileAlign={
                              item.mobileAlign ? item.mobileAlign : ""
                            }
                            Link={item.link}
                            element={item}
                            LinkName={item.linkname}
                            LinkType={item.linktype}
                            LinkOpen={item.linkopen}
                            UseSocial={item.use_social}
                            initP={this.props.initP}
                            userID={this.props.userID}
                            key={index}
                            sessionID={this.props.sessionID}
                            keyID={index}
                            ID={"f" + item.id}
                            srcID={item.srcID}
                            src={item.src}
                            style={item.style}
                            edit={item.edit}
                            showImageSetting={this.props.showImageSetting}
                            //imageClicked={this.state.imageClicked}
                            addImage={() => this.props.addImage(item.id)}
                            clickedImage={this.props.clickedImage}
                            clickedImageID={this.props.clickedImageID}
                            toggleUploadPopup={this.toggleUploadPopup}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            width={item.style.maxWidth}
                            height={item.style.height}
                            radius={item.style.borderRadius}
                            imageMarginUnit={item.style.imageMarginUnit}
                            marginTop={item.style.marginTop || 0}
                            marginRight={item.style.marginRight || 0}
                            marginBottom={item.style.marginBottom || 0}
                            marginLeft={item.style.marginLeft || 0}
                            float={item.style.float}
                            opacity={item.style.opacity}
                            URL={item.href}
                            changeImage={() => this.props.changeImage(item.id)}
                            cloneEle={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "Line") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <Line
                            display={item.style.display}
                            margin={item.style.margin}
                            key={index}
                            element={item}
                            lineMarginUnit={item.style.lineMarginUnit}
                            marginTop={item.style.marginTop}
                            marginRight={item.style.marginRight}
                            marginBottom={item.style.marginBottom}
                            marginLeft={item.style.marginLeft}
                            borderColor={item.style.borderColor}
                            borderWidth={item.style.borderWidth}
                            backgroundColor={item.style.backgroundColor}
                            style={item.style}
                            preset={this.props.preset}
                            width={item.style.width}
                            ID={"f" + item.id}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "TABLE") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <TABLEEditor
                            selectedFont={this.props.selectedFont}
                            mobileView={this.props.mobileView}
                            element={item}
                            ID={"f" + item.id}
                            edit={item.edit}
                            mobileContent={item.mobileStyle.content}
                            desktopContent={item.desktopStyle.content}
                            key={index}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.cloneEle(item.id)}
                            style={item.style}
                            tableMobileUnit={item.tableMobileUnit}
                            tableDesktopUnit={item.tableDesktopUnit}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "HTML") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <HTMLEditor
                            element={item}
                            mobileView={this.props.mobileView}
                            pagesList={this.props.pagesList}
                            ID={item.id}
                            edit={item.edit}
                            content={item.content}
                            key={index}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "TIMER") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <TimerElement
                            ID={"f" + item.id}
                            date={item.date}
                            key={index}
                            element={item}
                            size={item.size}
                            patternStyle={item.patternStyle}
                            float={item.style.float}
                            timerMarginUnit={item.style.timerMarginUnit}
                            marginTop={item.style.marginTop}
                            marginRight={item.style.marginRight}
                            marginBottom={item.style.marginBottom}
                            marginLeft={item.style.marginLeft}
                            margin={item.style.margin}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "TABLE") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <TABLEEditor
                            selectedFont={this.props.selectedFont}
                            element={item}
                            mobileView={this.props.mobileView}
                            pagesList={this.props.pagesList}
                            ID={item.id}
                            edit={item.edit}
                            mobileContent={item.mobileStyle.content}
                            desktopContent={item.desktopStyle.content}
                            isMirrored={item.isMirrored}
                            key={index}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.props.cloneEle(item.id)}
                            tableMobileUnit={item.tableMobileUnit}
                            tableDesktopUnit={item.tableDesktopUnit}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "FILE") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <File
                            marginTop={item.style.marginTop || 0}
                            marginBottom={item.style.marginBottom || 0}
                            fileMarginUnit={item.style.fileMarginUnit}
                            initP={this.props.initP}
                            userID={this.props.userID}
                            key={index}
                            sessionID={this.props.sessionID}
                            element={item}
                            keyID={index}
                            ID={"f" + item.id}
                            thumbID={item.thumbID}
                            thumb={item.thumb}
                            files={item.files}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneEle={() => this.props.cloneEle(item.id)}
                            style={item.style}
                            opacity={item.style.opacity}
                            radius={item.style.borderRadius}
                            width={item.style.maxWidth}
                            float={item.style.float}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "VIDEO") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <VideoElement
                            showChaptersToggle={item.showChaptersToggle}
                            if_src={item.src}
                            element={item}
                            key={index}
                            ID={"f" + item.id}
                            videoOption={() => {
                              this.props.videoOption(item.id);
                            }}
                            vimeoID={item.vimeoID || null}
                            youtubeID={item.youtubeID || null}
                            vimeoTHUMB={item.vimeoTHUMB || null}
                            youtubeTHUMB={item.youtubeTHUMB || null}
                            video_url={item.video_url || null}
                            videoURL_ADDRESS={
                              item.vimeoTHUMB
                                ? item.vimeoTHUMB
                                : item.youtubeTHUMB
                                ? item.youtubeTHUMB
                                : ""
                            }
                            deleteElement={() => this.props.deleteEle(item.id)}
                            VideoWidth={item.style.maxWidth}
                            srcID={item.srcID}
                            editEnable={item.edit}
                            marginTop={item.style.marginTop || 0}
                            marginBottom={item.style.marginBottom || 0}
                            videoMarginUnit={item.style.videoMarginUnit}
                            modalUpload={this.props.modalUpload}
                            selectedFile={this.props.selectedFile}
                            toggleUploadPopup={this.props.toggleUploadPopup}
                            dragLeave={this.props.dragLeave}
                            onChangeHandler={this.props.onChangeHandler}
                            loaded={this.props.loaded}
                            videoClicked={this.props.videoClicked}
                            videoDataID={this.props.videoDataID}
                            autoplay={item.autoplay}
                            modal={item.modal}
                            chapters={item.chapters}
                            control={item.control}
                            layout={this.props.layout}
                            userID={this.props.userID}
                            cloneEle={() => this.props.cloneEle(item.id)}
                            initP={this.props.initP}
                            sessionID={this.props.sessionID}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "FORM") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <Form
                            Layout={this.props.layout}
                            FormObj={item}
                            formArray={item.fields}
                            key={index}
                            element={item}
                            ID={"f" + item.id}
                            width={item.style.width}
                            borderWidth={item.style.borderWidth}
                            borderStyle={item.style.borderStyle}
                            borderRadius={item.style.borderRadius}
                            borderColor={item.style.borderColor}
                            formMarginUnit={item.style.formMarginUnit}
                            marginTop={item.style.marginTop || 0}
                            marginRight={item.style.marginRight || 0}
                            marginBottom={item.style.marginBottom || 0}
                            marginLeft={item.style.marginLeft || 0}
                            backgroundColor={item.style.backgroundColor}
                            color={item.style.color}
                            email={item.email}
                            deleteElement={() => this.props.deleteEle(item.id)}
                            cloneElement={() => this.props.cloneEle(item.id)}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                  if (item && item.data == "Row") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <RowColumns
                            chooseBlock={(e) => { this.chooseBlock(e, item, index) }}
                            tool={this.props.tool}
                            preset={this.props.preset}
                            ID={"f" + item.id}
                            onDragEnd={this.props.onDragEnd}
                            deleteEle={this.props.deleteEle}
                            cloneElement={this.props.cloneEle}
                            onAddElementorColumn={
                              this.props.onAddElementorColumn
                            }
                            element={item}
                            onAddElementorColumnInColumn={
                              this.props.onAddElementorColumnInColumn
                            }
                            mobileView={this.props.mobileView}
                            deskWidth={item.deskWidth}
                            gridGuideColumns={this.props.gridGuideColumns}
                            gridGuideGutterSpace={
                              this.props.gridGuideGutterSpace
                            }
                            index={index}
                            addedIndex={this.props.addedIndex}
                            getSizes={this.props.getSizes}
                            changeColmLayout={this.props.changeColmLayout}
                            resizeColumn={() => {
                              this.setState({
                                resizeID:
                                  this.state.resizeID == null ? item.id : null,
                              });
                            }}
                            resizeID={
                              this.state.resizeID == item.id ? true : false
                            }
                            // initP={this.state.initP}
                            userID={this.props.userID}
                            sessionID={this.props.sessionID}
                            rowStyle={item.rowStyle ? item.rowStyle : null}
                            rowBg={
                              item.rowStyle && item.rowStyle.rowBg
                                ? item.rowStyle.rowBg
                                : undefined
                            }
                            rowOpacity={
                              item.rowStyle && item.rowStyle.rowOpacity
                                ? item.rowStyle.rowOpacity
                                : "1.0"
                            }
                            rowBgColor={
                              item.rowStyle && item.rowStyle.rowBgColor
                                ? item.rowStyle.rowBgColor
                                : "transparent"
                            }
                            rowBorderColor={
                              item.rowStyle && item.rowStyle.rowBorderColor
                                ? item.rowStyle.rowBorderColor
                                : "#000000"
                            }
                            gutterSpaceBtwnCol={
                              item.rowStyle && item.rowStyle.gutterSpaceBtwnCol
                                ? item.rowStyle.gutterSpaceBtwnCol
                                : "0"
                            }
                            gutterSpaceBtwnColMobile={
                              item.rowStyle &&
                              item.rowStyle.gutterSpaceBtwnColMobile
                                ? item.rowStyle.gutterSpaceBtwnColMobile
                                : "0"
                            }
                            columnGap={
                              this.props.columnGap ? this.props.columnGap : "0"
                            }
                            rowGap={this.props.rowGap ? this.props.rowGap : "0"}
                            bgRepeat={
                              item.rowStyle && item.rowStyle.bgRepeat
                                ? item.rowStyle.bgRepeat
                                : "no-repeat"
                            }
                            bgSize={
                              item.rowStyle && item.rowStyle.bgSize
                                ? item.rowStyle.bgSize
                                : "cover"
                            }
                            borderWidth={
                              item.rowStyle && item.rowStyle.borderWidth
                                ? item.rowStyle.borderWidth
                                : "0"
                            }
                            rowCroppedBg={
                              item.rowStyle && item.rowStyle.croppedBg !== null
                                ? item.rowStyle.croppedBg
                                : undefined
                            }
                            rowBgWidth={
                              item.rowStyle && item.rowStyle.bgWidth
                                ? item.rowStyle.bgWidth
                                : undefined
                            }
                            columns={item.columns}
                            dragOverParent={
                              item.dataModule ? null : this.props.dragOverParent
                            }
                            dragOverColumn={
                              item.dataModule ? null : this.props.dragOverColumn
                            }
                            dragOverChildren={this.props.dragOverChildren}
                            onDragOver={
                              item.dataModule ? null : this.props.onDragOver
                            }
                            onDrop={item.dataModule ? null : this.onDrop}
                            onDrag={item.dataModule ? null : this.onDrag}
                            onDragOverItem={this.props.onDragOverItem}
                            addRemoveColumn={
                              item.dataModule
                                ? null
                                : this.props.addRemoveColumn
                            }
                            removeColumn={this.removeColumn}
                            itemID={this.props.itemID}
                            onDragLeaveItem={
                              item.dataModule
                                ? null
                                : this.props.onDragLeaveItem
                            }
                            imageClicked={this.props.imageClicked}
                            addImage={this.props.addImage}
                            changeImage={this.props.changeImage}
                            clickedImage={this.props.clickedImage}
                            clickedImageID={this.props.clickedImageID}
                            // layout={this.state.layout}
                            toggleUploadPopup={this.props.toggleUploadPopup}
                            dragLeave={this.props.dragLeave}
                            onChangeHandler={this.props.onChangeHandler}
                            modalUpload={this.props.modalUpload}
                            // selectedFile={this.state.selectedFile}
                            loaded={this.props.loaded}
                            videoClicked={this.props.videoClicked}
                            videoDataID={this.props.videoDataID}
                            videoOption={this.props.videoOption}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }

                  if (item && item.data == "Accordion") {
                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          this.chooseBlock(e,item, index);
                        }}
                        className={
                          this.state.choosenBlockElement.length > 0 &&
                          this.state.choosenBlockElement.includes(item)
                            ? " blockSelected"
                            : " "
                        }
                      >
                        <ErrorBoundary>
                          <Accordion
                            chooseBlock={(e) => { this.chooseBlock(e, item, index) }}
                            accordionNestType="accordionColumn"
                            dragOverColumn={this.props.dragOverColumn}
                            onDragLeaveParent={this.props.onDragLeaveParent}
                            onDragEnd={this.props.onDragEnd}
                            dragOverChildren={this.props.dragOverChildren}
                            onDragOver={this.props.onDragOver}
                            onDrop={this.props.onDrop}
                            onDragLeaveItem={this.props.onDragLeaveItem}
                            onDrag={this.props.onDrag}
                            onDragOverItem={this.props.onDragOverItem}
                            preset={this.props.preset}
                            selectedFont={this.props.selectedFont}
                            showAddElement={this.props.showAddElement}
                            tool={this.props.tool}
                            preventDrop={this.props.preventDrop}
                            pagesList={this.props.pagesList}
                            ID={item.id}
                            element={item}
                            onAddElementorColumn={
                              this.props.onAddElementorColumn
                            }
                            onAddElementorColumnInColumn={
                              this.props.onAddElementorColumnInColumn
                            }
                            deleteElement={() => {
                              this.props.deleteElement(item.id);
                            }}
                            cloneElement={() => {
                              this.props.cloneElement(item.id);
                            }}
              
                            payload={this.props.payload}
                            payloadActive={this.props.payloadActive}
                            changeColmLayout={this.props.changeColmLayout}
                            mobileView={this.props.mobileView}
                            resizeID={this.props.resizeID}
                            resizeColumn={() => {
                              this.props.resizeColumn(item.id);
                            }}
                            label={item.label}
                            deskWidth={item.deskWidth}
                            index={index}
                            addedIndex={this.props.addedIndex}
                            initP={this.props.initP}
                            userID={this.props.userID}
                            sessionID={this.props.sessionID}
                            rowStyle={item.rowStyle ? item.rowStyle : null}
                            rowBg={
                              item.rowStyle && item.rowStyle.rowBg
                                ? item.rowStyle.rowBg
                                : undefined
                            }
                            rowOpacity={
                              item.rowStyle && item.rowStyle.opacity
                                ? item.rowStyle.opacity
                                : "1.0"
                            }
                            rowBgColor={
                              item.rowStyle && item.rowStyle.rowBgColor
                                ? item.rowStyle.rowBgColor
                                : "transparent"
                            }
                            rowBorderColor={
                              item.rowStyle && item.rowStyle.rowBorderColor
                                ? item.rowStyle.rowBorderColor
                                : "#000000"
                            }
                            gutterSpaceBtwnCol={
                              item.rowStyle && item.rowStyle.gutterSpaceBtwnCol
                                ? item.rowStyle.gutterSpaceBtwnCol
                                : "0"
                            }
                            gutterSpaceBtwnColMobile={
                              item.rowStyle &&
                              item.rowStyle.gutterSpaceBtwnColMobile
                                ? item.rowStyle.gutterSpaceBtwnColMobile
                                : "0"
                            }
                            bgRepeat={
                              item.rowStyle && item.rowStyle.bgRepeat
                                ? item.rowStyle.bgRepeat
                                : "no-repeat"
                            }
                            bgSize={
                              item.rowStyle && item.rowStyle.bgSize
                                ? item.rowStyle.bgSize
                                : "cover"
                            }
                            borderWidth={
                              item.rowStyle && item.rowStyle.borderWidth
                                ? item.rowStyle.borderWidth
                                : "0"
                            }
                            rowCroppedBg={
                              item.rowStyle && item.rowStyle.croppedBg !== null
                                ? item.rowStyle.croppedBg
                                : undefined
                            }
                            rowBgWidth={
                              item.rowStyle && item.rowStyle.bgWidth
                                ? item.rowStyle.bgWidth
                                : undefined
                            }
                            columns={item.columns}
                            addRemoveColumn={this.props.addRemoveColumn}
                            removeColumn={this.props.removeColumn}
                            itemID={this.props.itemID}
                            imageClicked={this.props.imageClicked}
                            addImage={this.props.addImage}
                            changeImage={this.props.changeImage}
                            clickedImage={this.props.clickedImage}
                            clickedImageID={this.props.clickedImageID}
                            layout={this.props.layoutState}
                            toggleUploadPopup={this.props.toggleUploadPopup}
                            dragLeave={this.props.dragLeave}
                            onChangeHandler={this.props.onChangeHandler}
                            modalUpload={this.props.modalUpload}
                            selectedFile={this.props.selectedFile}
                            loaded={this.props.loaded}
                            videoClicked={this.props.videoClicked}
                            videoDataID={this.props.videoDataID}
                            addVideo={this.props.addVideo}
                            videoOption={this.props.videoOption}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  }
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaveAsBlock;
